import { TONE_CLASSES, type Tone } from "./tokens";

export interface BadgeProps {
  readonly label: string;
  readonly tone?: Tone;
}

// 色 + テキスト両方で表す(WCAG2: 色のみに依存しない)。
export function createBadge(props: BadgeProps): HTMLElement {
  const span = document.createElement("span");
  const tone = props.tone ?? "neutral";
  span.className =
    "inline-flex items-center rounded border px-2 py-0.5 text-xs font-medium " + TONE_CLASSES[tone].badge;
  span.textContent = props.label;
  return span;
}
